export default {"src":"/_next/static/media/crop-planning.30511903.gif","height":1448,"width":2206,"blurWidth":0,"blurHeight":0};